import React from 'react';
import { SearchIcon, XIcon } from 'lucide-react';
interface SearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit?: () => void;
  placeholder?: string;
  autoFocus?: boolean;
  label?: string;
}
export function SearchField({
  value,
  onChange,
  onSubmit,
  placeholder = 'Enter a number…',
  autoFocus = false,
  label = 'Search angel numbers'
}: SearchFieldProps) {
  return <form role="search" onSubmit={event => {
    event.preventDefault();
    onSubmit?.();
  }} className="group relative" data-id="element-76" data-mp="uruwmohqzrcu">
      <label className="sr-only" htmlFor="angel-search" data-id="element-77" data-mp="lyj20c3y5n17">
        {label}
      </label>
      <SearchIcon aria-hidden="true" className="pointer-events-none absolute left-4 top-1/2 h-[18px] w-[18px] -translate-y-1/2 text-lav-dim transition-colors duration-200 ease-smooth group-focus-within:text-aura-bright" strokeWidth={1.9} data-id="element-78" data-mp="lw53fta25sow" />
      <input id="angel-search" type="search" inputMode="text" autoComplete="off" autoFocus={autoFocus} value={value} onChange={event => onChange(event.target.value)} placeholder={placeholder} className="glass h-14 w-full rounded-2xl border-white/10 pl-12 pr-11 text-[16px] font-medium text-white outline-none transition-[border-color,box-shadow] duration-200 ease-smooth placeholder:font-normal placeholder:text-lav-dim focus:border-aura/60 focus:shadow-[0_0_30px_-10px_rgba(139,92,246,0.9)] [&::-webkit-search-cancel-button]:hidden" data-id="element-79" data-mp="71s8ukkv97k1" />
      {value.length > 0 && <button type="button" onClick={() => onChange('')} aria-label="Clear search" className="absolute right-3 top-1/2 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full text-lav-dim transition-colors duration-200 ease-smooth hover:bg-white/[0.06] hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-aura-bright/70" data-id="element-80" data-mp="c5gkhfakbd8e">
          <XIcon className="h-4 w-4" strokeWidth={2} data-id="element-81" data-mp="18cbbmb2vb338" />
        </button>}
    </form>;
}